import React from 'react';
import { useTranslation } from 'react-i18next';

export const LanguageSwitcher: React.FC = () => {
    const { i18n } = useTranslation();

    const toggleLanguage = () => {
        const nextLang = i18n.language.startsWith('en') ? 'ar' : 'en';
        i18n.changeLanguage(nextLang);
    };

    return (
        <button
            onClick={toggleLanguage}
            className="px-3 py-1 text-sm font-medium border border-white/20 rounded-full hover:bg-white/10 transition-colors"
            title="Toggle Language"
        >
            {i18n.language.startsWith('en') ? 'عربي' : 'English'}
        </button>
    );
};
